import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { v4 as uuidv4 } from "uuid";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { urtoast } from "../../../../Layouts/CustomPopup/eventEmitter";
import DisplayFileProper from "../../../../Common/FilesRelevent/DisplayFileProper";
import { validDocumentTypes, validImageTypes } from "../../../../../assests/extention/fileextention";
import { validateFileSignature } from "../../../../../utils/fileValidation";

const ALLOWED_TYPES = [
  ...validImageTypes,
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/zip",
];

export default function FileUpload1({ worksampleFiles, setWork_sample }) {
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleUpload = async (files) => {
    // Validate all files first
    const validationPromises = files.map((file) =>
      validateFileSignature(file, ALLOWED_TYPES),
    );
    const validationResults = await Promise.all(validationPromises);

    const isAnyInvalid = validationResults.some((isValid) => !isValid);
    if (isAnyInvalid) {
      urtoast("One or more files have an invalid type. Please upload valid images or documents.", 2);
      return;
    }

    const uploadPromises = files.map((file) => {
      if (file.size > 10 * 1024 * 1024) {
        urtoast(`File size exceeds 10MB limit.`);
        return Promise.reject(new Error("File size exceeds limit."));
      }

      const uniqueId = uuidv4(); // Generate a unique ID for each file
      const storageRef = ref(
        getStorage(),
        `/Category/${uniqueId}-${file.name}`
      );
      const uploadTask = uploadBytesResumable(storageRef, file);
      return uploadTask
        .then(async () => {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          return { name: file.name, file: url }; // Include the unique ID with the file URL
        })
        .catch((error) => {
          urtoast(`Error uploading ${file.name}: ${error.message}`);
          throw error;
        });
    });

    Promise.all(uploadPromises)
      .then((urls) => {
        const updatedFiles = [
          ...(Array.isArray(selectedFiles) ? selectedFiles : []),
          ...(Array.isArray(urls) ? urls : []),
        ];
        setSelectedFiles(updatedFiles);
        setWork_sample((prevData) =>
          [...(Array.isArray(prevData) ? prevData : []),
          ...(Array.isArray(urls) ? urls : []),],
        );
      })
      .catch((error) => {
        console.error("Error uploading files: ", error);
      });
  };

  const onDrop = (acceptedFiles) => {
    handleUpload(acceptedFiles);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const handleDeleteImage = (item) => {
    setSelectedFiles(prevFiles =>
      prevFiles.filter(file => file.file !== item.file)
    );
    // const updatedFiles = [...selectedFiles];
    // updatedFiles.splice(index, 1);
    // console.log(updatedFiles, "updatedFiles after delete")
    // setSelectedFiles(updatedFiles);
    setWork_sample(prevFiles =>
      prevFiles.filter(file => file.file !== item.file)
    );
  };

  useEffect(() => {
    setSelectedFiles(worksampleFiles);
  }, [worksampleFiles]);

  return (
    <div className="add-portfolio">
      <div className="row">
        {selectedFiles && selectedFiles.length === 0 ? (
          <div className="col-md-4">
            <div className="image-container">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/file-upload.png`}
                className="cover-img w-100"
                alt="Certificate"
              />
              {/* <button>
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                  alt=""
                />
              </button> */}
            </div>
          </div>
        ) : (
          selectedFiles &&
          selectedFiles.map((item, index) => (
            <div className="image-container col-md-4 " key={index}>
              <DisplayFileProper item={item} />
              <button
                type="button"
                className="delete-button"
                onClick={() => handleDeleteImage(item)}
              >
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                  alt="Delete"
                />
              </button>
            </div>
          ))
        )}
      </div>
      <div
        {...getRootProps({ className: "dropzone borderstylex" })}
        className="drag-drop"
      >
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the files here...</p>
        ) : (
          <p>
            Drag and drop or <span>Browse file</span>
          </p>
        )}
      </div>
      <ul className="border-ul">
        <li>Images (JPG, PNG, JPEG up to 10MB)</li>
        <li>Documents (PDF, DOCX, XLSX, PPTX, ZIP upto 10MB)</li>
      </ul>
    </div>
  );
}
